import { Badge, LuIcon, Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { getUserDisplayLabel } from "../../utils/users"
import { UserIcon } from "../Icons/UserIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type AssigneeSelectGroupProps = MenuSelectGroupProps<User | null> & {
	users: (User | null)[]
}

export const AssigneeSelectGroup = memo<AssigneeSelectGroupProps>((props) => {
	const { ref, users, ...rest } = props

	return (
		<Menu.SelectGroup<User | null> ref={ref} {...rest}>
			{users.map((user) => {
				return (
					<SelectItemTemplate<User | null> key={user?.id ?? "unassigned"} value={user}>
						{user ? (
							<>
								<UserIcon userId={user.id} size="xs" />
								<Text className="truncate">{getUserDisplayLabel(user)}</Text>
							</>
						) : (
							<>
								<Badge size="xs" icon radius="full" accentColor="base" variant="soft">
									<LuIcon icon={modelIconMapping.unassigned} />
								</Badge>
								<span className="truncate">Unassigned</span>
							</>
						)}
					</SelectItemTemplate>
				)
			})}
		</Menu.SelectGroup>
	)
})
AssigneeSelectGroup.displayName = "AssigneeSelectGroup"
